import { FaPaperPlane } from "react-icons/fa6";
import { cn } from "../../lib/utils.js";

/** Solid paper plane shared by Send now and the primary send action. Points right in both LTR and RTL. */
export function CampaignSendIcon({
  size = 13,
  className,
}: {
  size?: number;
  className?: string;
}): React.JSX.Element {
  return (
    <FaPaperPlane
      size={size}
      className={cn("shrink-0", className)}
      aria-hidden="true"
    />
  );
}
